import request from '@/config/axios'

export interface ReportVO {
  id: number
  reporterId: number
  reporterNickname?: string
  reporterAvatar?: string
  targetUserId: number
  targetNickname?: string
  targetAvatar?: string
  reportType: string
  content?: string
  images?: string
  auditStatus: number
  auditResult?: string
  auditTime?: string
  createTime: string
}

export const getReportPage = (params: any) =>
  request.get({ url: '/bosscircle/report/page', params })

export const handleReport = (data: { id: number; auditStatus: number; auditResult?: string }) =>
  request.put({ url: '/bosscircle/report/handle', data })
